<div class="card">
  <p-treeTable
    dataKey="id"
    [metaKeySelection]="true"
    [value]="nodes"
    [columns]="cols"
    selectionMode="checkbox"
    [(selection)]="selectedNodes"
    [scrollable]="true"
    [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="caption">
      <div class="flex">
        <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
        <span class="ml-2">Toggle All</span>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          *ngFor="let col of columns; let i = index"
          [ngClass]="{ 'w-1 text-center': i >= 1 }">
          <i *ngIf="col.icon" [class]="col.icon"></i>
          <span *ngIf="i === 0">{{ col.header }}</span>
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-rowNode
      let-rowData="rowData"
      let-columns="columns">
      <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode">
        <td
          *ngFor="let col of columns; let i = index"
          [ngClass]="{ 'w-1 text-center': i >= 1 }">
          <p-treeTableToggler
            [rowNode]="rowNode"
            *ngIf="i === 0"></p-treeTableToggler>
          <p-treeTableCheckbox
            [value]="rowNode"
            *ngIf="i === 0"></p-treeTableCheckbox>
          <ng-container>{{ rowData[col.field] }}</ng-container>
          <ng-container *ngIf="i >= 1">
            <p-checkbox [binary]="true"></p-checkbox>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-treeTable>
</div>
